import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginSuperAdminAPI, loginAPI } from '../../services/adminApiService';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';

const LoginPage = () => {

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    clientCode: '',
  });

  const [errors, setErrors] = useState({});
  const [apiResponse, setApiResponse] = useState(null);
  const navigate = useNavigate();
  // Function to set a cookie
  const setCookie = (name, value, days) => {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000); // Set expiration time
    const expires = `expires=${d.toUTCString()}`;

    // Adding SameSite and Secure attributes
    document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Strict; `;
  };

  // Function to get a cookie by name
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return '';
  };

  // Load stored cookies on initial render
  useEffect(() => {
    const savedUsername = getCookie('username');
    //const savedPassword = getCookie('password');
    const savedClientCode = getCookie('clientCode');

    if (savedUsername && savedClientCode) {
      setFormData((prevData) => ({
        ...prevData,
        username: savedUsername || '',
        clientCode: savedClientCode || ''
      }));
      /*setFormData({
        username: savedUsername || '',
       // password: savedPassword,
        clientCode: savedClientCode || '',
      });*/
    }
  }, []);



  const validateForm = () => {
    const newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = 'Username is required';
    }

    if (!formData.password.trim()) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 4) {
      newErrors.password = 'Password must be at least 4 characters';
    }

    if (!formData.clientCode.trim()) {
      newErrors.clientCode = 'clientCode is required';
    } //else if (!/^\d{4}$/.test(formData.clientCode)) {
    else if (formData.clientCode.length < 4) {
      newErrors.clientCode = 'clientCode must be a 4-digit number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
    setErrors((errors) => ({
      ...errors,
      [name]: ''
    }));
    //setFormData({ ...formData, [name]: value });
    //setErrors({ ...errors, [name]: '' }); // Clear error when user types
  };

  const handleClear = () => {
    setFormData({ username: '', password: '', clientCode: '' });
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      //console.log('Form Submitted', formData);
      // Add your form submission logic here
      try {
        let data
        if (formData.clientCode === '999999') {
          data = await loginSuperAdminAPI(formData);
        } else {
          data = await loginAPI(formData);
        }
        setApiResponse(data);
        //console.log("Data" + data);
        if (!data.error) { // Store JWT token
          // Store form data in cookies for future use
          setCookie('username', formData.username, 7); // Expires in 7 days
          setCookie('password', formData.password, 7);
          if (formData.clientCode != 999999) {
            setCookie('clientCode', formData.clientCode, 7);
          }
          navigate('/dashboard');
        } // Redirect to dashboard after login
      } catch (error) {
        // Checking if it's a 401 Unauthorized response
        if (error.response && error.response.status === 401) {
          return { error: 'Invalid credentials' };
        } else {
          console.error('Error during login:', error);
          return { error: 'An unexpected error occurred' };
        }
      }
    }
  };

  return (
    
      <motion.div
      className="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-500 to-indigo-600 p-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      style={{
        backgroundImage: "url('/q_login_bg.jpg')",
        backgroundSize: "cover",
      }}
    >
      
      <div className="bg-white/80 dark:bg-gray-900/80 p-8 rounded-2xl shadow-2xl max-w-md w-full backdrop-blur-md">
        <h2 className="text-3xl font-bold mb-6 text-center text-gray-800 dark:text-white">Login</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Username Field */}
          <div>
            <label className="block text-gray-700 dark:text-gray-300 mb-1">Username</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleInputChange}
              className={`w-full px-4 py-2 border ${errors.username ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 dark:text-white`}
              placeholder="Enter your username"
            />
            {errors.username && <p className="text-red-500 text-sm mt-1">{errors.username}</p>}
          </div>

          {/* Password Field */}
          <div>
            <label className="block text-gray-700 dark:text-gray-300 mb-1">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              className={`w-full px-4 py-2 border ${errors.password ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 dark:text-white`}
              placeholder="Enter your password"
            />
            {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
          </div>

          {/* Client Code Field */}
          <div>
            <label className="block text-gray-700 dark:text-gray-300 mb-1">Client Code</label>
            <input
              type="text"
              name="clientCode"
              value={formData.clientCode}
              onChange={handleInputChange}
              className={`w-full px-4 py-2 border ${errors.clientCode ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 dark:text-white`}
              placeholder="Enter your 6-digit client code"
            />
            {errors.clientCode && <p className="text-red-500 text-sm mt-1">{errors.clientCode}</p>}
          </div>

          {/* Buttons */}
          <div className="flex justify-between items-center">
            <button
              type="submit"
              className="w-1/2 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 transition-all"
            >
              Submit
            </button>
            <button
              type="button"
              onClick={handleClear}
              className="w-1/3 bg-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-400 focus:ring-2 focus:ring-gray-300 transition-all"
            >
              Clear
            </button>
          </div>
        </form>

        {/* API Response Message */}
        {apiResponse && (
          <motion.div
            className={`mt-4 flex items-center p-2 rounded-lg ${
              apiResponse.error ? "bg-red-100 text-red-600" : "bg-green-100 text-green-600"
            }`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {apiResponse.error ? (
              <>
                <FaExclamationCircle className="mr-2" />
                {apiResponse.error}
              </>
            ) : (
              <>
                <FaCheckCircle className="mr-2" />
                {apiResponse.success}
              </>
            )}
          </motion.div>
        )}
      </div>
    </motion.div>
    
  );
};

export default LoginPage;
